<template>
  <div
    class="suscripcion-widget d-none d-md-block"
    style="bottom: 220px; right: 0px"
    data-toggle="modal"
    data-target="#GodaddyPopUp"
  >
    <a title="SUSCRÍBASE"><img src="@/assets/widget-cotizacion.png" /> </a>
  </div>
</template>

<script>
export default {
  name: 'GodaddyWidget',
  props: ['configData'],
};
</script>
